export const NOTIFICATIONSHIDE = "hideNotifications";
